import { AnimatePresence, motion } from "framer-motion";
import { useState, useEffect } from "react";
import OpacityPage from "./../../layout/v6/OpacityPage";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

const Redeem = ({ item, onClose, currentStep }) => {
  const [step, setStep] = useState(currentStep);
  const [bg, setBg] = useState("#ECEEFF");
  const [locationId, setLocationId] = useState("");
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  useEffect(() => {
    setStep(currentStep);
  }, [currentStep, item]);

  const handleNext = (index) => {
    setStep(index);
    setBg("#E0F2EA");
    if ([2, 3].includes(index)) {
      setIsHeaderVisible(true);
    }
  };

  const handleClose = () => {
    onClose();
    setStep(1);
    setBg("#ECEEFF");
    setIsHeaderVisible(false);
  };

  return (
    <OpacityPage
      isOpen={!!item}
      onClose={handleClose}
      backgroundColor={bg}
      isHeaderVisible={isHeaderVisible}
    >
      {item && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-2xl p-[30px] max-xs:p-4 w-full max-w-md mx-6 flex flex-col gap-6"
          onClick={(e) => e.stopPropagation()}
        >
          <AnimatePresence mode="wait">
            {step === 1 && (
              <Step1
                item={item}
                handleNext={handleNext}
                handleClose={handleClose}
                locationId={locationId}
                setLocationId={setLocationId}
              />
            )}
            {step === 2 && <Step2 item={item} handleNext={handleNext} locationId={locationId} />}
            {step === 3 && <Step3 item={item} handleClose={handleClose} />}
          </AnimatePresence>

          <div className="absolute bottom-4 left-0 right-0 px-8 flex justify-between text-xs text-mid-gray">
            <p>Copyright © 2025 Rally</p>
            <p>
              Any issues? <span className="underline">Contact us</span>
            </p>
          </div>
        </motion.div>
      )}
    </OpacityPage>
  );
};

export default Redeem;
